export const FORBIDDEN_ROUTE = '/forbidden';

export const USER_READ_ROLE = 'USER_READ';
export const SUPER_USER_ROLE = 'SUPER_USER';
